import { useState, useEffect, useCallback } from 'react'
import { collectionsApi } from '../services/collectionsApi'
import type { Collection } from '../types/collections'

export const useCollections = () => {
  const [collections, setCollections] = useState<Collection[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchCollections = useCallback(async () => {
    try {
      setLoading(true)
      const data = await collectionsApi.list()
      setCollections(data)
      setError(null)
    } catch (err) {
      setError('Error fetching collections')
      console.error('Error fetching collections:', err)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchCollections()
  }, [fetchCollections])

  return { 
    collections, 
    loading, 
    error, 
    refetch: fetchCollections 
  }
}